export enum IdType {
  RSA_ID = 'RSA ID',
  PASSPORT = 'Passport',
}

export enum IdentityTypeDirectors {
  RSA_ID = 'id',
  PASSPORT = 'Passport',
  REFUGEE = 'Refugee',
  ASYLUM_SEEKER = 'Asylum Seeker',
}

export type Director = {
  idType?: IdentityTypeDirectors;
  title?: string;
  initials?: string;
  firstName?: string;
  surname?: string;
  idNumber?: string;
  passportNumber?: string;
  dateOfBirth?: Date;
  gender?: string;
  passportExpiryDate?: Date;
  countryOfOrigin?: string;
};

export type DirectorDetails = {
  directors: Director[];
};
